import React, {useContext} from 'react';
import UseContext from "hooks/useContext";
import SidebarUnitMobile from "components/sidebar/components/SidebarUnitMobile";

const IdentityValidationML = ({pathname}) => {
    const {language}=UseContext()
    return (
        <SidebarUnitMobile routeName={"Tableau de bord"} routeSidebar={"/identity_validation"}>
            <div className="flex flex-col justify-center items-center ">

            {/*<span className='shrink-0'>
                            <DashboardIcon wh={45} color={`${pathname === '/dashboard' ? '#FF9600' : '#6B7280'}`}/>
            </span>*/}
                <span
                    className={`text-[9px] font-medium whitespace-normal text-center ${
                        pathname.includes("identity_validation") && "!text-[#FF9600]"
                    }`}
                >
            {language.getValue('sidebar.identity_validation','Validation d\'identité')}
          </span>
            </div>
        </SidebarUnitMobile>
    );
};

export default IdentityValidationML;